<template>
  <div
    class="tag"
    :style="{ 'background-color': tagColor, color: tagTextColor }"
    data-test-id="Tag"
    @click="onClick(tag)"
  >
    <span>{{ tag.name }}</span>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { getContrastColorFor } from "@/Case/services/ColorContrast";
// eslint-disable-next-line no-unused-vars
import { ITag } from "@/Case/models/ITag";
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";

@Component
export default class Tag extends Vue {
  @Prop() readonly tag!: ITag;
  @Prop() readonly color!: string;
  @Prop() readonly tagsSelected!: ITag[];

  tagColor: string = "";
  tagTextColor: string = "";

  created(): void {
    this.setTagColors();
  }

  setTagColors(): void {
    this.tagColor = this.getTagColor();
    this.tagTextColor = getContrastColorFor(this.tagColor);
  }

  getTagColor(): string {
    return this.isTagSelected(this.tag) ? this.color : "#FFFFFF";
  }

  isTagSelected(tag: ITag): boolean {
    return this.tagsSelected.some((selectedTag) => selectedTag.id == tag.id);
  }

  onClick(tag: ITag): void {
    this.$emit(CaseEvent.MODIFY, {
      eventType: CaseUpdateEventType.tag,
      data: { tag },
    });
  }

  @Watch("tagsSelected")
  onTagsSelectedChanged(): void {
    this.setTagColors();
  }
}
</script>

<style scoped>
.tag {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 10px;
  border-radius: 4px;
  word-break: break-all;
  font-weight: bold;
  background-color: #fff;
  color: #000;
  user-select: none;
}
</style>
